
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initSentry } from './lib/sentry';

initSentry();


// Clear any cached data in localStorage that might be causing issues
// This is a one-time fix that will run on app startup
const clearStaleCache = () => {
  try {
    console.log("Clearing potential stale cache on app load");
    
    // Add app version to detect changes
    const currentVersion = '1.0.4'; // Increment this when making major changes
    const storedVersion = localStorage.getItem('app-version');
    
    if (storedVersion !== currentVersion) {
      console.log("App version changed, clearing cache");
      
      // Clear auth-specific items that might be causing issues
      localStorage.removeItem('supabase.auth.token');
      localStorage.removeItem('supabase.auth.expires_at');
      
      // Clear only app-related cache, not auth tokens
      Object.keys(localStorage).forEach(key => {
        if (key.startsWith('app-') || key.startsWith('cache-') || key.startsWith('layout-')) {
          localStorage.removeItem(key);
        }
      });
      
      localStorage.setItem('app-version', currentVersion);
    }
  } catch (e) {
    console.error("Error clearing cache:", e);
  }
};

clearStaleCache();

// Create a container div that ensures the app has full width
const prepareRootElement = () => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    rootElement.className = 'w-full h-full';
    // Ensure body and html are full width and centered
    document.body.className = 'w-full h-full m-0 p-0';
    document.documentElement.className = 'w-full h-full';
  }
  return rootElement;
};

// Strict mode helps catch bugs by rendering components twice in development
createRoot(prepareRootElement()!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
